module.exports = __webpack_public_path__ + "img/banana-loading.09648a08.png";